/**
 * WallpaperPicker Component
 * Renders preset wallpaper grid, custom URL input, blur, and opacity sliders.
 */
import React, { useState } from 'react';
import { Check, Image as ImageIcon, Sliders } from 'lucide-react';
import { WALLPAPER_PRESETS } from '../hooks/useAppSettings';

export function WallpaperPicker({
  settings,
  selectWallpaper,
  setCustomWallpaper,
  updateSetting,
}) {
  const [customInput, setCustomInput] = useState(settings.customWallpaperUrl || '');

  const handleApplyCustom = (e) => {
    e.preventDefault();
    if (customInput.trim()) {
      setCustomWallpaper(customInput.trim());
    }
  };

  return (
    <div className="wallpaper-picker">
      <div className="setting-subgroup">
        <label className="setting-label">Bộ hình nền có sẵn</label>
        <div className="wallpaper-grid">
          {WALLPAPER_PRESETS.map((preset) => {
            const isSelected = settings.wallpaperId === preset.id;
            return (
              <button
                key={preset.id}
                className={`wallpaper-card ${isSelected ? 'selected' : ''}`}
                onClick={() => selectWallpaper(preset.id)}
                style={{
                  background: preset.url ? `url(${preset.url}) center/cover no-repeat` : preset.thumbnail,
                }}
                title={preset.name}
              >
                <span className="wallpaper-name">{preset.name}</span>
                {isSelected && (
                  <span className="wallpaper-check-badge">
                    <Check size={14} />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Custom URL Input */}
      <div className="setting-subgroup">
        <label className="setting-label">Hoặc dùng ảnh nền từ link mạng (URL)</label>
        <form className="custom-wallpaper-form" onSubmit={handleApplyCustom}>
          <div className="custom-input-wrapper">
            <ImageIcon size={16} className="custom-input-icon" />
            <input
              type="url"
              placeholder="Dán link ảnh (https://...)"
              value={customInput}
              onChange={(e) => setCustomInput(e.target.value)}
              className="custom-url-input"
            />
          </div>
          <button type="submit" className="custom-apply-btn">
            Áp dụng
          </button>
        </form>
      </div>

      {/* Sliders for Blur & Overlay */}
      {settings.wallpaperId !== 'default' && (
        <div className="setting-subgroup sliders-subgroup">
          <div className="setting-slider-item">
            <div className="slider-header">
              <span className="slider-title">
                <Sliders size={14} /> Độ mờ hậu cảnh (Blur)
              </span>
              <span className="slider-value">{settings.backgroundBlur}px</span>
            </div>
            <input
              type="range"
              min="0"
              max="16"
              step="1"
              value={settings.backgroundBlur}
              onChange={(e) => updateSetting('backgroundBlur', Number(e.target.value))}
              className="settings-range"
            />
          </div>

          <div className="setting-slider-item">
            <div className="slider-header">
              <span className="slider-title">Độ tối nền tương phản (Overlay)</span>
              <span className="slider-value">{Math.round(settings.backgroundOverlayOpacity * 100)}%</span>
            </div>
            <input
              type="range"
              min="0.1"
              max="0.8"
              step="0.05"
              value={settings.backgroundOverlayOpacity}
              onChange={(e) => updateSetting('backgroundOverlayOpacity', Number(e.target.value))}
              className="settings-range"
            />
          </div>
        </div>
      )}
    </div>
  );
}
